/**
 * Validates a grade value against a range, accounting for inverted scales
 * @param value - The value to validate
 * @param range - The range to validate against
 * @param isInverted - Whether the scale is inverted (min > max)
 * @param t - Translation function
 * @returns Validation result with error message if invalid
 */
export const validateGradeInRange = (value, range, isInverted, t) => {
    if (value === undefined || Number.isNaN(value) || !range) {
        return { isValid: true };
    }
    const { minValue, maxValue } = range;
    // For non-inverted scales: value should be between min and max
    // For inverted scales: value should be >= max OR <= min
    if (!isInverted) {
        if (value < minValue || value > maxValue) {
            return {
                isValid: false,
                errorMessage: t('Please enter value between {min} and {max}', {
                    values: { min: minValue, max: maxValue },
                }),
            };
        }
    }
    else {
        if (value > minValue || value < maxValue) {
            return {
                isValid: false,
                errorMessage: t('Please enter value between {min} and {max}', {
                    values: { min: minValue, max: maxValue },
                }),
            };
        }
    }
    return { isValid: true };
};
/**
 * Validates a percentage value (0-100)
 * @param value - The value to validate
 * @param t - Translation function
 * @returns Validation result with error message if invalid
 */
export const validatePercentage = (value, t) => {
    if (value === undefined || Number.isNaN(value)) {
        return { isValid: true };
    }
    if (value > 100) {
        return {
            isValid: false,
            errorMessage: t('Value must be less than or equal to 100'),
        };
    }
    if (value < 0) {
        return {
            isValid: false,
            errorMessage: t('Value must be greater than or equal to 0'),
        };
    }
    return { isValid: true };
};
/**
 * Validates a grade value for "greater than" comparison in a range
 * Adjusts minimum by -1 for greater than comparisons
 */
export const validateGreaterThanGrade = (value, range, isInverted, t) => {
    if (value === undefined || Number.isNaN(value) || !range) {
        return { isValid: true };
    }
    const adjustedRange = {
        minValue: range.minValue - 1,
        maxValue: range.maxValue,
    };
    return validateGradeInRange(value, adjustedRange, isInverted, t);
};
/**
 * Checks if a grading scale is inverted (min > max)
 */
export const isInvertedScale = (range) => {
    if (!range)
        return false;
    return range.minValue > range.maxValue;
};
